'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitForm = exports.clearCookie = exports.sessionifyCookie = exports.getCookie = undefined;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

var _dontTrack = require('./dont-track');

var _dontTrack2 = _interopRequireDefault(_dontTrack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
  Share With Lender: 3b49f652-0510-4592-a87c-ceb2e7c09d62
  Dashboard Data Gathering: b237b9ee-5c31-4152-bd97-4f7cd51186b2
*/

var hubspotCookieId = 'hubspotutk';

var getCookie = exports.getCookie = function getCookie() {
  return _jsCookie2.default.get(hubspotCookieId);
};

var sessionifyCookie = exports.sessionifyCookie = function sessionifyCookie() {
  var cookie = getCookie();
  _jsCookie2.default.set(hubspotCookieId, cookie, {
    domain: '.ownup.com',
    expires: undefined
  });
};

var clearCookie = exports.clearCookie = function clearCookie() {
  return _jsCookie2.default.remove(hubspotCookieId, { domain: '.ownup.com' });
};

var submitForm = exports.submitForm = function submitForm(formId, data) {
  if (_dontTrack2.default) {
    return Promise.resolve();
  }
  var url = 'https://forms.hubspot.com/uploads/form/v2/2658322/' + formId;
  var payload = Object.assign({
    hs_context: JSON.stringify({
      hutk: getCookie()
    })
  }, data);
  return fetch(url + '?' + _querystring2.default.stringify(payload), {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};


// WEBPACK FOOTER //
// ./node_modules/@rategravity/frontend/modules/hubspot.js